// extracted by mini-css-extract-plugin
export var changelingNeoFont = "Changeling Neo";
export var darkColor = "#262626";
export var interFont = "Inter";
export var lightColor = "#f0f0f0";
export var microgrammaExtdDBoldFont = "Microgramma Extd D Bold";
export var oswaldFont = "Oswald";
export var pathwayGothicOneFont = "Pathway Gothic One";
export var poppinsFont = "Poppins";
export var primaryColor = "#d7172f";
export var secondaryColor = "#666";
export var shuttleblockCondensedFont = "Shuttleblock Condensed";
export var spaceGroteskVariableFont = "Space Grotesk Variable";
export var zenTokyoZooFont = "Zen Tokyo Zoo";